import React from 'react'

import { MdSettings } from 'react-icons/md'
import { MdClose } from 'react-icons/md'

import '../style/alert-action-bar.scss'

const AlertActionBar = ({ canEditSettings, toggleSettings, closeClicked, isSettingsOpen }) =>
  <div className='alert-action-bar'>
    {canEditSettings && <button type='button' aria-label='Alert Settings' onClick={() => toggleSettings(!isSettingsOpen)}>
      <MdSettings size='24' style={{ verticalAlign: 'bottom' }} />
    </button>}
    <button type='button' aria-label='Close Alerts' onClick={() => closeClicked(true)}>
      <MdClose size='26' style={{ verticalAlign: 'bottom' }} />
    </button>
  </div>

export default AlertActionBar
